/** Public visé : mode de la page (bailleur ou locataire) et type de compte (home "/pro"). */
export type BandeauAudience = "bailleur" | "pro" | "locataire";

export const BANDEAU_AUDIENCES: BandeauAudience[] = [
  "bailleur",
  "pro",
  "locataire",
];

export const BANDEAU_AUDIENCE_LABELS: Record<BandeauAudience, string> = {
  bailleur: "Bailleurs",
  pro: "Pros",
  locataire: "Locataires",
};

export interface BandeauInformation {
  id: number;
  titre: string | null;
  texte: string | null;
  lien: string | null;
  /** Ouvre « Voir l'offre » dans un nouvel onglet ; sinon sur la page courante. */
  lien_nouvel_onglet: boolean;
  audiences: BandeauAudience[];
  created_at: string;
  retired_at: string | null;
}
